import React from 'react'
import { ModelWithForm, WhenModel, WhenModelValue, WhenNotLoading } from '@morningtrain/react-resources'
import Smartview from 'widgets/smartviews/Smartview'
import * as Displays from '@morningtrain/react-displays'
import useActiveShift from 'support/hooks/use-active-shift'
import * as Auth from '@morningtrain/react-auth'
import ShiftExchangeDetails from 'widgets/shifts/exchange/ShiftExchangeDetails'
import SmartviewContentSeparator from 'widgets/smartviews/partials/SmartviewContentSeparator'
import ShiftSmartviewEditForm from 'widgets/smartviews/shifts/ShiftSmartviewEditForm'
import ShiftSmartviewReadView from 'widgets/smartviews/shifts/ShiftSmartviewReadView'
import * as UI from 'ui'
import ShiftSmartviewProfileView from 'widgets/smartviews/shifts/ShiftSmartviewProfileView'

function ViewShiftSmartview ({ mode = 'view' }) {
  const format = 'YYYY-MM-DD HH:mm:ss'
  const [activeShift] = useActiveShift()

  return (
    <ModelWithForm resourceName='shifts.schedule_slot' id={activeShift}>
      <WhenModelValue name='id' condition={activeShift}>
        <Smartview header={(
          <UI.WithSubtitle subtitle={(
            <UI.Text weight='medium' size='lg'>
              <Displays.Date name='start_at' dateFormat='dddd - D MMMM' />
            </UI.Text>
            )}
          >
            <span>
              <Displays.Date name='start_at' dateFormat='HH:mm' parseFormat={format} />
              <span> - </span>
              <Displays.Date name='end_at' dateFormat='HH:mm' parseFormat={format} />
            </span>
          </UI.WithSubtitle>
          )}
        >

          <ShiftSmartviewProfileView />
          {mode === 'plan'
            ? (
              <>
                <Auth.CanUseModel permission='api.shifts.schedule_slot.store' negate>
                  <ShiftSmartviewReadView />
                </Auth.CanUseModel>
                <Auth.CanUseModel permission='api.shifts.schedule_slot.store'>
                  <ShiftSmartviewEditForm slotId={activeShift} />
                  <SmartviewContentSeparator />
                </Auth.CanUseModel>
              </>
              )
            : (
              <ShiftSmartviewReadView />
              )}
          <SmartviewContentSeparator />
          <ShiftExchangeDetails />
        </Smartview>
      </WhenModelValue>
    </ModelWithForm>
  )
}

export default ViewShiftSmartview
